export function getName(aroeven: Aroeven, title: boolean = true) {
    if (aroeven.federation === true) {
        return (title === false ? 'la ' : '') + 'Fédération des Aroéven'
    }
    return (title === false ? 'l\' ' : '') + 'Aroéven ' + aroeven.name
}

export function getStaffByRole(aroeven: AroevenStaffs, role: string) {
    return aroeven.staffs.filter(staff => staff.roles.includes(role))[0] ?? null
}